import sleep from 'utils/sleep'
import { OperationError } from '../common/error'

// TODO 模拟获取手机验证码
// 随机生成手机验证码，打印到console
export async function generateVericode (mobileVerification) {
  await sleep(200)
  if (Math.random() < 0.5) throw new OperationError('获取验证码错误')
  let data = {phone: mobileVerification.phone, verificationCode: Math.round(Math.random() * 1000000).toString()}
  sessionStorage.setItem('mobileVerification', JSON.stringify(data))
  console.log(data)
}

// 验证手机验证码
export async function verify (mobileVerification) {
  await sleep(200)
  let veri_buf = sessionStorage.getItem('mobileVerification')
  if (Math.random() < 0.5) throw new OperationError('网络连接异常')
  if (JSON.parse(veri_buf).phone === mobileVerification.phone) {
    if (JSON.parse(veri_buf).verificationCode === mobileVerification.verificationCode) return true
    throw new OperationError('验证码不正确')
  }
  throw new OperationError('验证码不正确')
}

// 验证手机是否注册过
let registeredPhone = ['17600185295', '17610865295']

export async function isRegistered (mobileVerification) {
  await sleep(200)
  for (let currentValue of registeredPhone) {
    if (currentValue === mobileVerification.phone) {
      return true
    }
  }
  throw new OperationError('该手机号未注册，如有疑问请联系管理员')
}

// 存储新密码
export async function newPasswordConfirm (pwdVerification) {
  await sleep(200)
  if (Math.random() > 0.5) return true
  throw new OperationError('保存密码失败')
}



// WEBPACK FOOTER //
// ./src/api/MobileVeriCode.js